import { useDispatch } from 'react-redux';
import { IllustrativeIcon, Surface, Txt } from '@vst/beam';
import { Alert } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { CustomStandardModal } from '@app/components/Modal';
import { setPurchaseRetentionOfferError } from '@app/redux/disconnect';

import { ModalProps } from '../../types';

import styles from './index.module.scss';

const ErrorModal = ({ isOpen, handleCancel }: ModalProps) => {
  const { t } = useTranslation('Disconnect');
  const dispatch = useDispatch();
  return (
    <CustomStandardModal
      isOpen={isOpen}
      onClose={handleCancel}
      size="medium"
      header={''}
      actions={{
        primary: {
          label: t('retentionOffers.errorModal.primaryButton'),
          onClick: () => {
            handleCancel?.();
            dispatch(setPurchaseRetentionOfferError(false));
          },
        },
      }}
    >
      <Surface className={styles.modalContentWrapper}>
        <IllustrativeIcon icon={Alert} color={'teal_600'} size={'80px'} mb={'16px'} />
        <Txt variant="heading5">{t('retentionOffers.errorModal.title')}</Txt>
        <Txt variant="bodySmallRegular" color="subtle">
          {t('retentionOffers.errorModal.description')}
        </Txt>
      </Surface>
    </CustomStandardModal>
  );
};

export default ErrorModal;
